module.exports = __webpack_public_path__ + "img/katarina_bedrooms_27.df929683.jpg";